import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import appConfig from '@app/app.config';

/*
The motivations for the fetch call below are threefold:
1. To allow the CI/CD pipeline to inject the correct configuration for deployed environments
2. To support running the local env on bare metal
3. To support running the local env in a docker container

All docker environments auto generate /assets/config.json
When running outside of a docker environment the fetch call to /assets/config.json
will fail and the app will fall back to the default config found in client/src/app/app.config.ts
*/

function bootstrapApp(config = null) {
  appConfig.setConfig(config);
  enableProdMode();
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error('Bootstrap error:', err));
}

fetch('/api/config')
  .then((response) => response.ok ? response.json() : null)
  .then((config) => bootstrapApp(config))
  .catch((err) => {
    console.warn('Failed to load /api/config, starting with defaults:', err);
    bootstrapApp(null);
  });
